import styled from "styled-components";

const INPUT_HEIGHT = "29px";

export const Container = styled.div`
  font-size: 12px;
  padding: 0 0 40px 0;
  margin-right: 20px;
  margin-bottom: 26px;
  border-bottom: 1px solid #AFAFAF;
`

export const ChangeValueContainer = styled.div`
  display: flex;
  margin-top: 15px;
`;

export const StyledBox = styled.div`
  display: flex;
  align-items: center;
  min-width: 158px;
  height: ${INPUT_HEIGHT};
  padding-left: 10px;
  margin-right: 50px;
  background-color: ${({ theme }) => theme.orangeBackground};
  border-radius: 15px;
  font-weight: 600;
  color: #fff;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledCheckbox = styled.input`
  width: 20px;
  height: 20px;
`;

export const StyledInput = styled.input<{ error: boolean }>`
  width: 120px;
  height: ${INPUT_HEIGHT};
  border: ${props => props.error ? "2px solid red" : "0.5px solid #808080"};
  border-radius: 3px;
  color: #808080;
  text-align: center;
`;
